import type { Module } from 'vuex'

export type LoginFlowData = {
  email: string
  token?: string
  /** The path to be redirect after a login via magic link */
  redirectPath?: string
}

export type LoginFlowDataOTPStep = Omit<LoginFlowData, 'token'> & {
  token: string
}

function defaultState(): LoginFlowData {
  return {
    email: '',
    token: undefined,
    redirectPath: undefined,
  }
}

const loginFlowStore: Module<LoginFlowData, LoginFlowData> = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    email(state: LoginFlowData, email: LoginFlowData['email']) {
      state.email = email
    },
    token(state: LoginFlowData, token?: LoginFlowData['token']) {
      state.token = token
    },
    redirectPath(state: LoginFlowData, redirectPath?: LoginFlowData['redirectPath']) {
      state.redirectPath = redirectPath
    },
  },
  actions: {
    setData({ commit }, data: LoginFlowData) {
      commit('email', data.email)
      commit('token', data.token)
      commit('redirectPath', data.redirectPath)
    },
    clearAll({ dispatch }) {
      dispatch('setData', defaultState())
    },
  },
  getters: {
    all(state: LoginFlowData): LoginFlowData {
      return state
    },
    email(state: LoginFlowData): string {
      return state.email
    },
    token(state: LoginFlowData): string | undefined {
      return state.token
    },
    redirectPath(state: LoginFlowData): string | undefined {
      return state.redirectPath
    },
  },
}

export default loginFlowStore
